module.exports = __webpack_public_path__ + "resources/img/img-acra-point-01-m-en.45febaf86f7a7fb12cd65dbb4ccb9b5a.png";